<div nz-row>
  <div nz-col nzSpan="2"></div>
  <div nz-col nzSpan="20">

    <!--页头-->
    <nz-card nzSize="small" class="breadcrumb-card">
      <nz-breadcrumb>
        <nz-breadcrumb-item>
          <a [routerLink]="">Home</a>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item>
          PPI KG
        </nz-breadcrumb-item>
      </nz-breadcrumb>
    </nz-card>

    <div nz-row>
      <div nz-col nzXl="7" nzSm="24">
        <app-graph-search></app-graph-search>
      </div>
      <div nz-col nzXl="1" nzSm="24"></div>
      <div nz-col nzXl="16" nzSm="24">
        <app-graph-visual [showDownloadButton]="true"></app-graph-visual>
      </div>
    </div>




  </div>
  <div nz-col nzSpan="2"></div>
</div>





